import { Component, Injector, HostListener } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import { TimeOutService } from '../../../shared/services/timeout.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { RequiredDocuments } from '../../../shared/models/Enum/RequiredDocuments';

@Component({
  selector: 'md-document-uploader',
  template: require('./document-uploader.component.html'),
  styles: [require('./document-uploader.component.scss')]
})
export class DocumentUploaderComponent extends BaseRoute {

  loading = true;
  id;
  applicationId;
  isSubmitting = false;
  submitted = false;
  subscriptions = new Subscription();
  applicantType = 'UNKNOWN';

  constructor(injector: Injector, timeOutService: TimeOutService) {
    super(injector);
    this._timeOutService = timeOutService;
  }

  ngOnInit() {
    this.appActions.setData('stepUserIsOn', 0);
    this.documentRequestId = this.appActions.getData('DocumentUploader.id');
    this.applicationId = this.appActions.getData('DocumentUploader.applicationId');
    const inputs = this.form.inputs;
    this.form.inputs = [];
    this.appProxy.getDocumentStatus(this.documentRequestId, resp => {
      if (resp && !resp.error && !resp.code) {
        // Set application type so we know what success email type to send
        this.applicantType = resp.length === 1 ? resp[0].applicantType.toUpperCase() : 'BOTH';
        // Go through each applicant and display only the required documents
        resp.forEach(applicant => {
          // if no doc type or doc type does not match specified types, display miscellaneous upload
          if (!applicant.documents.length || applicant.documents.some(document =>
            !RequiredDocuments.includes(document))) {
            applicant.documents.push('MISC'); this.hasMiscellaneous = true;
          }
          // If user comes from welcome-back page they won't have an applicationId
          if (!this.applicationId) {
            this.applicationId = applicant.applicationId;
            this.appActions.setData('DocumentUploader.applicationId', this.applicationId);
          }
          inputs.forEach(input => {
            // Use the spread operator to clone the object, if not it will edit the original
            const tmpInput = { ...input };
            if (input.inputType === 'header') {
              tmpInput.title = `${applicant.firstName} ${applicant.lastName}`;
            } else {
              const displayDocument = this.shouldDisplayDocument(applicant.documents, tmpInput);
              if (displayDocument) {
                tmpInput.attr.id = displayDocument + '-' + applicant.applicantType;
                tmpInput.inputPath = input.inputPath + applicant.applicantType;
                tmpInput.showUp = true;
              }
            }
            if (tmpInput.showUp) {
              this.form.inputs.push(tmpInput);
            }
          });
        });
      }
      this.loading = false;
    });
    this.subscriptions.add(this._timeOutService.timedOut$.pipe(distinctUntilChanged()).subscribe(timedOut => {
      if (timedOut && !this.submitted) {
        this.sendUploadLaterEmail();
      }
    }));
  }

  shouldDisplayDocument(documents, input) {
    let result = false;
    documents.forEach(document => {
      input.documents.forEach(inputdocument => {
        // Check if it should be added and only if it isn't already added
        if (document.indexOf(inputdocument) !== -1 && !this.form.inputs.includes(input)) {
          result = document;
        }
      });
    });
    return result;
  }

  // Must send email if user closes or navigated away from the page without submitting
  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event) {
    if (!this.submitted) {
      this.sendUploadLaterEmail();
    }
  }

  sendUploadLaterEmail() {
    this.flowManager.resetPageError();
    const values = {
      documentRequestId: this.appActions.getData('DocumentUploader.id'),
      type: 'UPLOAD_LATER',
      payload: {}
    };
    this.appProxy.sendEmail(values, resp => {});
  }

  updateOptionValue(event) {

  }

  btnClick(event) {
    const files = this.appActions.getData('DocumentUploader.files');
    if (event.action === 'next' && !this.isSubmitting) {
      this.isSubmitting = true;
      event.event.target.classList.add('spinner');
      const values = {
        documentRequestId: this.documentRequestId,
        files: files ? Object.keys(files).map(e => files[e]) : []
      };
      this.appProxy.postDocuments(values, resp => {
        this.isSubmitting = false;
        if (resp.status === 'SUCCESS') {
          this.submitted = true;
          const emailValues = {
            documentRequestId: this.appActions.getData('DocumentUploader.id'),
            type: this.applicantType,
            payload: {}
          };
          this.appProxy.sendSuccessEmail(emailValues, resp => {});
          this.router.navigate(['document-confirmation-received'], { queryParamsHandling: 'preserve' });
        } else {
          event.event.target.classList.remove('spinner');
          this.sendNoSelectionEmail();
          this.router.navigate(['error-submitting-app'], { queryParamsHandling: 'preserve' });
        }
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
